<app-list-module-table
  variant="surface"
  [columns]="columns"
  [rows]="rows"
  [loading]="loading"
  [emptyMessage]="emptyMessage"
  rowTrackKey="agent_id"
>
  <ng-template listCellDef="agent" let-row="row">
    <div class="flex flex-col leading-tight">
      @if ((P.REPORT_VIEW | hasPermission) && detailLink(row); as link) {
      <a
        class="truncate font-medium text-primary hover:underline"
        [routerLink]="link"
        [queryParams]="detailQueryParams"
        [title]="row.agent_name"
        >{{ row.agent_name }}</a
      >
      } @else {
      <span class="truncate font-medium text-gray-900 dark:text-white" [title]="row.agent_name">{{ row.agent_name }}</span>
      }
      <span class="font-mono text-xs text-gray-500 dark:text-gray-400">{{ row.agent_id }}</span>
    </div>
  </ng-template>

  <ng-template listCellDef="client" let-row="row">
    <span [title]="row.client_name">{{ row.client_name }}</span>
  </ng-template>

  <ng-template listCellDef="product" let-row="row">
    {{ row.product_type }}
  </ng-template>

  <ng-template listCellDef="totalPds" let-row="row">
    {{ row.total_pds }}
  </ng-template>

  <ng-template listCellDef="outcomes" let-row="row">
    @let state = outcomeState(row);
    @switch (state.kind) {
      @case ('chips') {
      <div class="flex flex-wrap items-center gap-1">
        @for (chip of state.chips; track chip.key) {
        <span class="rounded-full px-2 py-0.5 text-xs font-medium" [ngClass]="chip.cls" [title]="chip.tooltip">{{ chip.count }} {{ chip.label }}</span>
        }
      </div>
      }
      @case ('unscored') {
      <span class="text-xs text-gray-400">Not yet scored</span>
      }
      @default {
      <span class="text-xs text-gray-400">No PDs yet</span>
      }
    }
  </ng-template>

  <ng-template listCellDef="duration" let-row="row">
    {{ durationDisplay(row) }}
  </ng-template>

  <ng-template listCellDef="lastPd" let-row="row">
    {{ row.last_pd_date ? (row.last_pd_date | date: 'dd MMM yyyy') : '—' }}
  </ng-template>

  <ng-template listCellDef="actions" let-row="row">
    @if ((P.REPORT_VIEW | hasPermission) && hasDetailLink(row)) {
    <button
      type="button"
      class="inline-flex items-center gap-1 rounded-lg border border-primary/30 px-2.5 py-1 text-xs font-medium text-primary hover:bg-primary/10"
      [attr.aria-label]="'View report for ' + row.agent_name"
      (click)="view.emit(row)"
    >
      <icon-eye class="h-3.5 w-3.5" />
      View
    </button>
    } @else {
    <span class="text-xs text-gray-400">—</span>
    }
  </ng-template>
</app-list-module-table>
